<template>
  <div class="header-right-info">
    <a-dropdown>
      <div class="user-style">
        <a-icon type="user" />
        <span>{{ (userInfo && userInfo.realname) || "暂无" }} </span>
      </div>
      <a-menu slot="overlay" @click="handleClick">
        <template v-for="(action, index) in actionList">
          <a-menu-item :key="action.type">
            {{ action.text }}
          </a-menu-item>
          <a-menu-divider :key="index" v-if="action.divider" />
        </template>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import cookieUtil from "@/common/cookie-util";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "HeaderRightInfo",
  data() {
    return {
      actionList: [
        {
          type: "userInfo",
          text: "个人信息",
          icon: "",
          showPlain: true,
          divider: false,
        },
        {
          type: "logout",
          text: "退出登录",
          icon: "logout",
          showPlain: true,
          divider: false,
        },
      ],
      id: "",
      InformList: [],
      InformCount: 0,
      userInfo: {},
    };
  },
  computed: {
    // ...mapGetters("app", ["userInfo", "count"]),
    limitedInformList() {
      return this.InformList.slice(0, 3);
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    ...mapMutations("app", ["setTagList"]),
    ...mapActions("app", ["getCount"]),
    handleClick({ key }) {
      if (key === "logout") {
        this.$apis.components
          .logout()
          .then((res) => {
            this.setTagList([]);
            // cookieUtil.removeToken();
            localStorage.removeItem("admin_token");
            location.reload();
            localStorage.removeItem("menuState");
          })
          .catch((e) => {
            this.$message.error({ content: "操作失败!", key, duration: 2 });
          });
        return;
      }
      this.$router.push({ path: "/userInfo", query: { id: this.userInfo.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.header-right-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 40px;
  .user-style {
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 0.9rem;
    span {
      margin-left: 5px;
    }
  }
}
</style>
